import { COLORS } from 'consts/colors'
import {
  MOBILE_SIZE_BREAKPOINT,
  NARROW_SCREEN_SIZE_BREAKPOINT,
  SMALL_DESKTOP_SIZE_BREAKPOINT
} from 'consts'
import styled from 'styled-components'
import { ActionsContainer } from 'common-components/ActionsOverlay/styled'

export const Item = styled.div`
  max-width: 164px;
  width: 100%;
  height: 94px;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  overflow: hidden;
  position: relative;

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    aspect-ratio: 16/9;
    max-width: 48%;
    height: auto;
  }

  [aria-label] {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      inset: -10px;
    }
  }

  ${ActionsContainer} {
    padding: 4px;
  }
`

export const ThumbnailImage = styled.img<{ $hidden?: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
`

export const FallbackVideo = styled.video<{ $hidden?: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
`

export const PreviewVideo = styled.video<{ $isLoading: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
`

export const ProcessingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`

export const SkeletonOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

export const VideoDuration = styled.div`
  position: absolute;
  bottom: 4px;
  left: 4px;
  font-size: 8px;
  color: white;
  background-color: ${COLORS.secondaryExtraDark};
  border-radius: 4px;
  padding: 2px 4px;
`

export const PreviewButton = styled.div`
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLORS.white};
  border: 1px solid ${COLORS.secondarySemiLight};
  border-radius: 4px;
  cursor: pointer;
  z-index: 4;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  ${Item}:hover & {
    opacity: 1;
  }

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    opacity: 1;
  }

  &::after {
    content: '';
    position: absolute;
    inset: -10px;
  }

  svg {
    width: 14px;
    height: 14px;
    fill: ${COLORS.secondarySemiDark};
  }

  &:hover {
    border-color: ${COLORS.secondary};
    background: ${COLORS.primaryLight};

    svg {
      fill: ${COLORS.secondaryDark};
    }
  }
`

export const PreviewContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1090px;
  gap: 16px;
  position: relative;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    flex-direction: column;
  }

  @media screen and (min-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    min-width: 840px;
  }

  @media screen and (min-width: ${NARROW_SCREEN_SIZE_BREAKPOINT}px) {
    min-width: 1060px;
  }
`

export const VideoPreviewWrapper = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 800px;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  position: relative;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
    max-width: 100%;
    flex: none;
    max-height: 50vh;
    overflow: unset;
  }
`

export const PreviewSkeletonOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

export const VideoPreviewVideo = styled.video`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: contain;
`
export const VideoPreviewConent = styled.div`
  width: 274px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
  }
`

export const SlideUpScrollable = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
`

export const SlideUpActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  border-top: 1px solid ${COLORS.borderColor};
  gap: 12px;
`

export const PopupActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 16px;
`
